export default __webpack_public_path__ + "static/media/email_sent.c3bdf700.svg";